import { combinedAlertsDataActions } from "../../../state/combined-alerts-data";
import { useDispatch, useSelector } from "react-redux";

import { IRootState } from "../../../state";
import {
  ICommonWPClass,
  IExpressAvailability,
  IScratchpayRenewalPending,
  IUpdatePaymentMethod,
} from "../../../services/get-alerts/get-alerts.interface";

export const useCombinedAlertsDataStore = () => {
  const dispatch = useDispatch();
  const {
    isDuplicateAccount,
    isExpressEligible,
    shouldShowWellnessUpSell,
    shouldShowPrequalification,
    urgentVisitUpSell,
    updatePaymentMethod,
    alertsDataUpdated,
    //  wellness plan alerts
    recentlyEndedWPData,
    failedRenewalsAfterGracePeriodWPData,
    failedRenewalsWithGracePeriodWPData,
    recentRenewedWPData,
    endsSoonWPData,
    failedRenewalsWPData,
    scratchpayRenewalPending,
    referralUpSell,
  } =
  useSelector((state: IRootState) => state.combinedAlertsData);

  const setIsDuplicateAccount = (payload: boolean) => {
    dispatch(combinedAlertsDataActions.setIsDuplicateAccount(payload));
  };

  const setShouldShowWellnessUpsell = (payload: boolean) => {
    dispatch(combinedAlertsDataActions.setShouldShowWellnessUpsell(payload));
  };

  const setShouldShowPrequalification = (payload: boolean) => {
    dispatch(combinedAlertsDataActions.setShouldShowPrequalification(payload));
  };

  const setShowUrgentVisitUpsell = (payload: boolean) => {
    dispatch(combinedAlertsDataActions.setShowUrgentVisitUpsell(payload));
  };
  const setIsExpressEligible = (payload: IExpressAvailability[]) => {
    dispatch(combinedAlertsDataActions.setIsExpressEligible(payload));
  };
  const setUpdatePaymentMethod = (payload: IUpdatePaymentMethod[]) => {
    dispatch(combinedAlertsDataActions.setUpdatePaymentMethod(payload));
  };
  const setAlertsDataUpdated = (payload: boolean) => {
    dispatch(combinedAlertsDataActions.setAlertsDataUpdated(payload));
  };

  //  wellness alerts
  const setRecentlyEndedWPData = (payload: ICommonWPClass[]) => {
    dispatch(combinedAlertsDataActions.setRecentlyEndedWPData(payload));
  };

  const setFailedRenewalAfterGrace = (payload: ICommonWPClass[]) => {
    dispatch(combinedAlertsDataActions.setFailedRenewalAfterGrace(payload));
  };

  const setFailedRenewalWithGrace = (payload: ICommonWPClass[]) => {
    dispatch(combinedAlertsDataActions.setFailedRenewalWithGrace(payload));
  };

  const setRecentRenewedWPData = (payload: ICommonWPClass[]) => {
    dispatch(combinedAlertsDataActions.setRecentRenewedWPData(payload));
  };

  const setEndsSoonWPData = (payload: ICommonWPClass[]) => {
    dispatch(combinedAlertsDataActions.setEndsSoonWPData(payload));
  };

  const setFailedRenewalWPData = (payload: ICommonWPClass[]) => {
    dispatch(combinedAlertsDataActions.setFailedRenewalWPData(payload));
  };

  const setShowReferralUpsell = (payload: boolean) => {
    dispatch(combinedAlertsDataActions.setShowReferralUpsell(payload));
  };

  const setScratchpayRenewalPending = (payload: IScratchpayRenewalPending[]) => {
    dispatch(combinedAlertsDataActions.setScratchpayRenewalPending(payload));
  };

  return {
    isDuplicateAccount,
    isExpressEligible,
    shouldShowWellnessUpSell,
    shouldShowPrequalification,
    urgentVisitUpSell,
    updatePaymentMethod,
    alertsDataUpdated,
    recentlyEndedWPData,
    failedRenewalsAfterGracePeriodWPData,
    failedRenewalsWithGracePeriodWPData,
    recentRenewedWPData,
    endsSoonWPData,
    failedRenewalsWPData,
    scratchpayRenewalPending,
    referralUpSell,
    setIsDuplicateAccount,
    setShouldShowWellnessUpsell,
    setShouldShowPrequalification,
    setShowUrgentVisitUpsell,
    setIsExpressEligible,
    setUpdatePaymentMethod,
    setAlertsDataUpdated,
    setRecentlyEndedWPData,
    setFailedRenewalAfterGrace,
    setFailedRenewalWithGrace,
    setRecentRenewedWPData,
    setEndsSoonWPData,
    setFailedRenewalWPData,
    setScratchpayRenewalPending,
    setShowReferralUpsell,
  };
};

export default useCombinedAlertsDataStore;
